import type { ObjetivoSelf, PlanoTier, TermoSecao } from '../types';

export const WIZARD_STEP_LABELS = [
  'Objetivo',
  'Perfil',
  'Parâmetros',
  'Revisão',
  'Pagamento',
] as const;

export const WIZARD_STEP_ORDER: Record<string, number> = {
  objetivo: 0,
  perfil: 1,
  parametros: 2,
  revisao: 3,
  pagamento: 4,
  errorPayment: 4,
};

export const OBJETIVO_LABELS: Record<ObjetivoSelf, string> = {
  desocupacao: 'Desocupação',
  valores: 'Valores vencidos',
  clausula: 'Cláusula arbitral',
};

export const OBJETIVOS_VALIDOS = Object.keys(OBJETIVO_LABELS) as ObjetivoSelf[];

export const OBJETIVOS_SEM_PARAMETROS: readonly ObjetivoSelf[] = ['clausula'];

export const PLANO_TIER_LABELS: Record<PlanoTier, string> = {
  starter: 'Starter',
  intermediario: 'Intermediário',
};

export const PLANO_TIER_PRECOS_MENSAIS: Record<PlanoTier, string> = {
  starter: '1.990',
  intermediario: '4.990',
};

// TODO: teste de contrato comparando SELF_TERMOS_VERSAO com SELF_TERMOS_VERSOES_ACEITAS do core-api (deriva silenciosa vira 400 em produção).
export const SELF_TERMOS_VERSAO = '2026-08-05';

export const MENSAGEM_ACEITE_OBRIGATORIO = 'Aceite os termos de uso para continuar.';

export const BUSCA_CONTEXTO_MENSAGENS = [
  'Estamos buscando informações sobre sua empresa. Isso pode levar alguns segundos.',
  'Estou entendendo o que a sua empresa faz.',
  'Já estou quase lá — organizando o que encontrei para você.',
];

export const AGENTE_CHECKLIST = [
  'Parâmetros aplicados',
  'Configurando o agente',
  'Preparando o simulador',
];

export const TERMOS_SECOES: TermoSecao[] = [
  {
    titulo: '1. Coleta de Dados',
    corpo:
      'A Lexi coleta informações da empresa e do usuário exclusivamente para a configuração e operação do agente autônomo. Essas informações incluem dados de cadastro, preferências de negociação e interações realizadas dentro da plataforma. O uso desses dados segue rigorosamente a Lei Geral de Proteção de Dados (LGPD) e é estritamente necessário para o funcionamento do serviço.',
  },
  {
    titulo: '2. Uso do Serviço',
    corpo:
      'A Lexi é uma ferramenta de auxílio e automação. O usuário é responsável por revisar a produção do agente antes da publicação final. A plataforma não substitui a supervisão humana e não assume responsabilidade por decisões tomadas exclusivamente com base nas interações do agente sem revisão adequada.',
  },
  {
    titulo: '3. Propriedade Intelectual',
    corpo:
      'Todo o código, arquitetura de inteligência artificial e modelos de linguagem utilizados pela Lexi pertencem à Arbitralis. O conteúdo gerado pelo agente para o cliente é de propriedade do cliente contratante, desde que esteja em conformidade com as leis aplicáveis e os direitos autorais de terceiros.',
  },
  {
    titulo: '4. Cancelamento',
    corpo:
      'O cliente pode cancelar o plano a qualquer momento. Valores pagos não são reembolsáveis, salvo casos previstos no Código de Defesa do Consumidor (CDC) ou em legislação aplicável. O cancelamento não afeta o acesso aos dados gerados durante o período de assinatura.',
  },
  {
    titulo: '5. Limitação de Responsabilidade',
    corpo:
      'A Arbitralis não se responsabiliza por decisões tomadas exclusivamente com base nas interações do agente sem supervisão humana. A plataforma é fornecida "como está" e "conforme disponível". Em hipótese alguma, a Arbitralis será responsável por danos indiretos, incidentais, especiais ou consequenciais decorrentes do uso da Lexi.',
  },
  {
    titulo: '6. Política de Privacidade',
    corpo:
      'Nossa Política de Privacidade detalha como coletamos, armazenamos e protegemos as informações pessoais dos usuários. Respeitamos a privacidade dos nossos clientes e comprometemo-nos a manter a confidencialidade dos dados em conformidade com as leis aplicáveis.',
  },
  {
    titulo: '7. Cookies',
    corpo:
      'Utilizamos cookies e tecnologias de rastreamento para melhorar a experiência do usuário, monitorar o desempenho da plataforma e personalizar conteúdo. Você pode gerenciar suas preferências de cookies a qualquer momento.',
  },
  {
    titulo: '8. Contato',
    corpo:
      'Para dúvidas, solicitações de exclusão de dados ou esclarecimentos sobre estes Termos, entre em contato com nosso time de privacidade através do e-mail: privacidade@arbitralis.com.br.',
  },
];
